var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutubeSquare(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.173 8.353l4.675 2.657-4.675 2.657V8.353zM22 2.357v17.286A2.358 2.358 0 0119.643 22H2.357A2.358 2.358 0 010 19.643V2.357A2.358 2.358 0 012.357 0h17.286A2.358 2.358 0 0122 2.357zm-2.063 8.658s0-2.927-.373-4.332a2.24 2.24 0 00-1.581-1.59c-1.39-.38-6.983-.38-6.983-.38s-5.593 0-6.983.378a2.243 2.243 0 00-1.581 1.591c-.373 1.4-.373 4.332-.373 4.332s0 2.927.373 4.331a2.21 2.21 0 001.581 1.567c1.39.373 6.983.373 6.983.373s5.593 0 6.983-.378a2.21 2.21 0 001.581-1.567c.373-1.4.373-4.326.373-4.326z",
    fill: "#000",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeSquare);
export default __webpack_public_path__ + "static/media/youtube-square.21dadb21.svg";
export { ForwardRef as ReactComponent };